// Container that owns the drill-down state for the Trips area.
// Keeps list <-> detail <-> truck/pick-route/CMR switching in one route,
// mirroring the standalone test rig shell without requiring URL-level splits.

import React, { Suspense, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';

import TripsPage from './TripsPage.js';

const TruckLoadPage = React.lazy(() => import('./TruckLoadPage.js'));
const PickRoutePage = React.lazy(() => import('./PickRoutePage.js'));
const CmrPage = React.lazy(() => import('./CmrPage.js'));

export default function TripsContainer() {
  const [truckTripCode, setTruckTripCode] = useState(null);
  const [pickRouteTripCode, setPickRouteTripCode] = useState(null);
  const [cmrTripCode, setCmrTripCode] = useState(null);

  const mode = truckTripCode
    ? 'truck'
    : pickRouteTripCode
      ? 'pick-route'
      : cmrTripCode
        ? 'cmr'
        : 'list';

  if (mode === 'truck') {
    return (
      <Suspense
        fallback={
          <Container className="py-5 text-center">
            <Spinner animation="border" /> Loading 3D view…
          </Container>
        }
      >
        <TruckLoadPage code={truckTripCode} onBack={() => setTruckTripCode(null)} />
      </Suspense>
    );
  }

  if (mode === 'pick-route') {
    return (
      <Suspense
        fallback={
          <Container className="py-5 text-center">
            <Spinner animation="border" /> Loading pick route…
          </Container>
        }
      >
        <PickRoutePage code={pickRouteTripCode} onBack={() => setPickRouteTripCode(null)} />
      </Suspense>
    );
  }

  if (mode === 'cmr') {
    return (
      <Suspense
        fallback={
          <Container className="py-5 text-center">
            <Spinner animation="border" /> Loading CMR…
          </Container>
        }
      >
        <CmrPage code={cmrTripCode} onBack={() => setCmrTripCode(null)} />
      </Suspense>
    );
  }

  return (
    <TripsPage
      onOpenTruckView={setTruckTripCode}
      onOpenPickRoute={setPickRouteTripCode}
      onOpenCmr={setCmrTripCode}
    />
  );
}
